import ResultIndex from '@/views/result/index.vue';
import ResultTeacher from '@/views/result/teacher/index.vue';
import ResultStudent from '@/views/result/student/index.vue';
import ResultPrincipal from '@/views/result/principal/index.vue';
import ResultStatus from '@/views/result/teacher/Status.vue'; 
import ResultAnalysis from '@/views/result/principal/Analysis.vue'; 

import ResultLitStudent from '@/views/result/ai-literacy/student/index.vue';

const routes = [ 
  {
    path: "/result",
    component: ResultIndex,
    meta: { title: "검사 결과" },
    children: [      
      {
        path: "teacher",
        name: "ResultTeacher",
        component: ResultTeacher,
        meta: { title: "교사 검사 결과" },
      },
      {
        path: "student",
        name: "ResultStudent",
        component: ResultStudent,
        meta: { title: "학생 검사 결과" },
      },     
      
      {
        path: "principal/:schoolType?",
        name: "ResultPrincipal",
        component: ResultPrincipal,
        props: true,
        meta: { title: "교장 검사 결과" },
      }, 
      {
        path: "teacher/status",
        name: "ResultStatus",
        component: ResultStatus,
        meta: { title: "교사 검사 상태" },
      },
      {
        path: "principal/analysis",
        name: "ResultAnalysis",
        component: ResultAnalysis,
        meta: { title: "교장 검사 분석" },
      },         
      {       
        path: "principal/:schoolType?/analysis",
        name: "ResultAnalysisElementary",
        component: ResultAnalysis,
        props: true,
        meta: { title: "교장 검사 분석" },
      },
    ]
  },   
];

export default routes;